import React from 'react';
import image from "../../assets/img/page/who-we-are.jpg";
import Count from '../common/count';

const Certification = () => {
    return (
        <>
        <div className="certification section-padding pt-0">
            <div className="container">
                <div className="row">
                    <div className="col-xl-4 col-lg-5 lg-mb-25">
                        <div className="certification-left section-padding pb-0">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Our Achievements</span>
                            <h2 className="title_split_anim">Our Achievements Over the Years</h2>
                            <p className="wow fadeInUp" data-wow-delay=".6s">Each milestone reflects our dedication to doing things the right way — with honesty, craftsmanship, and heart.</p>
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-7">
                        <div className="certification-right">
                            <img className="wow img_top_animation" src={image} alt="image" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="counter__one-area mt-80">
                            <div className="certification-right-counter">
                                <h2><Count number={300}/>+</h2>
                                <p>Completed Projects</p>
                            </div>
                            <div className="certification-right-counter">
                                <h2><Count number={15}/>+</h2>
                                <p>Team Members</p>
                            </div>
                            <div className="certification-right-counter">
                                <h2><Count number={250}/>+</h2>
                                <p>Satisfied Clients</p>
                            </div>
                            <div className="certification-right-counter">
                                <h2><Count number={100}/>%</h2>
                                <p>Customer Retention Rate</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
        </>
    );
};

export default Certification;